import { Globals } from "../CoreApp/Globals";

export function doUploadPubContent() {
  var g = Globals._bookRenderInfo;
  var pp = g.fPubPanel;

  Globals._uploadPubContent = false;
  pp.DoPostBook("append");

  // Do transaction to upload partial stream
  // Transaction returns to doPageRender
  //doPageRender();
}
